export default {
  COOKIE_DOMAIN: ';domain=.teko.vn',
  CURRENT_NAMESPACE: 'api_doc_fe_namespace',
  APP_THEME: 'api_doc_fe_theme',
};
